import { CompanyCreate, ProductCreate } from "../../api";
import { makeAddNewCallback } from "../../redux/slices/addNew";
import { configProps } from "../../types";
import { getCountryName } from "../../helpers/countryNames";
import { downloadContractBody } from "../../components/downloadContractBody";

export const goodsToTakeAwayConfig: configProps<"goodsToTakeAway"> = {
  view: "goodsToTakeAway",
  title: "Towar do zabrania",
  columns: [
    {
      id: 1,
      field: "date",
      header: "Data",
      isDefaultVisible: true,
      className: "column--extra-small",
      inputType: "calendar",
      isDefaultSort: true,
      sortOrder: -1 as const,
      required: true,
    },
    {
      id: 2,
      field: "startDate",
      header: "Termin realizacji: od",
      isDefaultVisible: true,
      className: "column--extra-small",
      inputType: "calendar",
      required: true,
    },
    {
      id: 3,
      field: "endDate",
      header: "Termin realizacji: do",
      isDefaultVisible: true,
      className: "column--extra-small",
      inputType: "calendar",
      required: true,
    },
    {
      id: 4,
      field: "client",
      header: "Firma",
      isDefaultVisible: true,
      className: "column--flexible",
      inputType: "dropdown",
      optionsKey: "suppliers",
      enableFilter: true,
      required: true,
      allowAddNew: makeAddNewCallback({
        field: "client",
        type: "company",
        makeInitialValues: ({ initialValueString: name }) =>
          ({
            name,
            is_buyer: false,
            is_transporter: false,
            is_supplier: true,
          }) satisfies Partial<CompanyCreate>,
      }),
    },
    {
      id: 5,
      field: "contractNumber",
      header: "Nr. kontraktu",
      isDefaultVisible: true,
      className: "column--small",
      inputType: "text",
      required: true,
    },
    {
      id: 6,
      field: "paymentDeadlineDays",
      header: "Termin p.",
      isDefaultVisible: false,
      className: "column--extra-small",
      inputType: "number",
    },
    {
      id: 8,
      field: "price",
      header: "Cena",
      isDefaultVisible: true,
      className: "column--extra-small",
      inputType: "number",
      required: true,
    },
    {
      id: 9,
      field: "weight",
      header: "Ilość",
      isDefaultVisible: true,
      className: "column--extra-small",
      inputType: "number",
    },
    {
      id: 10,
      field: "broker",
      header: "Broker",
      isDefaultVisible: false,
      className: "column--medium",
      inputType: "text",
    },
    {
      id: 11,
      field: "brokerInvoice",
      header: "Fa broker",
      isDefaultVisible: false,
      className: "column--medium",
      inputType: "text",
    },
    {
      id: 12,
      field: "product",
      header: "Towar",
      isDefaultVisible: false,
      className: "column--dropdown",
      inputType: "dropdown",
      optionsKey: "products",
      enableFilter: true,
      required: true,
      allowAddNew: makeAddNewCallback({
        field: "product",
        type: "product",
        makeInitialValues: ({ initialValueString: name }) =>
          ({
            name,
          }) satisfies Partial<ProductCreate>,
      }),
    },
    {
      id: 13,
      field: "location",
      header: "Miejsce",
      isDefaultVisible: true,
      className: "column--medium",
      inputType: "dropdown",
      optionsKey: "locations",
      allowAddNew: makeAddNewCallback({
        field: "location",
        type: "address",
        makeInitialValues: ({ initialValueString: address }) => ({ address }),
      }),
    },
    {
      id: 14,
      field: "city",
      header: "Miasto",
      isDefaultVisible: true,
      className: "column--medium",
      editable: false,
      optionsKey: "cities",
      enableFilter: true,
      formGroup: "none",
    },
    {
      id: 15,
      field: "country",
      header: "Kraj",
      isDefaultVisible: true,
      className: "column--medium",
      editable: false,
      body: (rowData) => getCountryName(rowData.country),
      formGroup: "none",
    },
    {
      id: 16,
      field: "deliveredWeight",
      header: "Ilość dost.",
      headerIcon: "check-circle",
      formGroup: "none",
      isDefaultVisible: true,
      className: "column--extra-small",
      inputType: "text",
      required: false,
      editable: false,
    },
    {
      id: 17,
      field: "remainingWeight",
      header: "Do dost.",
      headerIcon: "hourglass",
      formGroup: "none",
      isDefaultVisible: true,
      className: "column--extra-small",
      inputType: "text",
      required: false,
      editable: false,
    },
    {
      id: 18,
      field: "estimatedWeight",
      header: "Zaawiz",
      formGroup: "none",
      isDefaultVisible: false,
      className: "column--extra-small",
      inputType: "text",
      required: false,
      editable: false,
    },
    {
      id: 19,
      field: "missingWeight",
      header: "Brak",
      formGroup: "none",
      isDefaultVisible: false,
      className: "column--extra-small",
      inputType: "text",
      required: false,
      editable: false,
    },
    {
      id: 20,
      field: "canDownload",
      header: "Pobierz",
      formGroup: "none",
      isDefaultVisible: true,
      className: "column--extra-small column--no-padding",
      editable: false,
      sortable: false,
      body: downloadContractBody,
    },
    {
      id: 21,
      field: "signed",
      header: "Podpisana?",
      isDefaultVisible: true,
      className: "column--extra-small",
      inputType: "toggle",
      editable: true,
      enableFilter: true,
      optionsKey: "boolean",
      formGroup: "none",
    },
  ],
};
